module.exports = __webpack_public_path__ + "static/img/14010207.89f5c20b.png";